import React from 'react';

const DangerCircle = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Danger Circle">
        <path
          id="Stroke 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.00033 1.29175C13.257 1.29175 16.7087 4.74258 16.7087 9.00008C16.7087 13.2567 13.257 16.7084 9.00033 16.7084C4.74283 16.7084 1.29199 13.2567 1.29199 9.00008C1.29199 4.74258 4.74283 1.29175 9.00033 1.29175Z"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 3"
          d="M8.99577 5.83685V9.51935"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 5"
          d="M8.99648 12.1634H9.00482"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default DangerCircle;
